<template>
  <button :class="mode">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: ['mode']
}
</script>

<style scoped>
  button,
  a {
    text-decoration: none;
    padding: 0.80rem 2.5rem;
    font: inherit;
    font-size: 30px;
    background-color: #eaf8f8;
    border: 5px solid #c4c4c4;
    color: black;
    cursor: pointer;
    border-radius: 10px;    
    display: inline-block;
    margin-left: 30px;
    margin-bottom: 30px;
  }
  
  a:hover,
  a:active,
  button:hover,
  button:active {
    background-color: #6b6b6b;
    border-color: #000000;
  }
  
  </style>